const TemplateIcon = ({ className = "" }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    width="1em"
    height="1em"
  >
    {/* Corner circles */}
    <circle cx="3" cy="3" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="21" cy="3" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="3" cy="21" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="21" cy="21" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />

    {/* Connecting lines */}
    <line x1="5" y1="3" x2="19" y2="3" stroke="currentColor" strokeWidth="1.5" />
    <line x1="5" y1="21" x2="19" y2="21" stroke="currentColor" strokeWidth="1.5" />
    <line x1="3" y1="5" x2="3" y2="19" stroke="currentColor" strokeWidth="1.5" />
    <line x1="21" y1="5" x2="21" y2="19" stroke="currentColor" strokeWidth="1.5" />

    {/* Top box */}
    <rect x="6" y="6" width="12" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="9" y="8" width="6" height="1" fill="currentColor" />

    {/* Bottom box */}
    <rect x="6" y="13" width="12" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <rect x="9" y="15" width="6" height="1" fill="currentColor" />
  </svg>
);

export default TemplateIcon;
